const baseUrl = "https://static.vivamoselcampo.co/uploads/prizes";
const prizesList = [
  {
    title: "Emprendimiento Inspiracional Apps.co 2015",
    image: `${baseUrl}/apps-co.jpg`,
    description: `Fuimos catalogados como Emprendimiento Inspiracional durante nuestra participación en la séptima
    iteración de la convocatoria Apps.co del Ministerio de las Tecnologías de la Información y las Comunicaciones de
    Colombia, convirtiéndonos también en uno de los proyectos ganadores del programa.`,
    seeMore: 'https://youtu.be/f17qudRSUGE?si=IEr93fRDcuTJu5dm'
  },
  {
    title: "Empresario del Mes 2016 Cámara de Comercio Tunja",
    image: `${baseUrl}/empresario-del-mes-camara-comercio.jpeg`,
    description: `Douglas Jairo Velásquez, lider del proyecto Vivamos el Campo – Turismo Rural, fue declarado
    Empresario del Mes de Junio de 2016 por la Cámara de Comercio de Tunja, resaltando sus ganas de emprender sin
    importar la edad, y el compromiso que tiene Vivamos el Campo con los propietarios de Alojamientos Rurales.`
  },
  {
    title: "Ganadores Alianzas para la Innovación 2017",
    image: `${baseUrl}/alianzas-innovacion.jpeg`,
    description: `Participamos en la convocatoria Alianzas Para la Innovación, impulsada por Confecámaras, la Cámara
    de Comercio de Tunja y Colciencias, en la cual resultamos escogidos como ganadores junto con otros dos emprendimientos.`
  },
  {
    title:
      "Ganadores Concurso de Productos Innovadores de Base Tecnológica 2017",
    image: `${baseUrl}/productos-innovadores-camara-comercio-tunja.jpeg`,
    description: `Participamos en el Concurso de Productos Innovadores de Base Tecnológica, convocatoria realizada por la
    Gobernación de Boyacá y la Cámara de Comercio de Tunja, resultando seleccionados como uno de los 5 emprendimientos ganadores.`,
    seeMore: 'https://www.boyaca.gov.co/con-equipos-fueron-premiados-ganadores-de-concurso-de-productos-innovadores-de-base-tecnologica/'
  },
  {
    title: "Nominación Premios Emprender SENA 2019",
    image: `${baseUrl}/premio-emprender-sena.jpeg`,
    description: `Fuimos postulados por el Servicio Nacional de Aprendizaje (SENA) en los Premios Emprender 2019, organizados
    por dicha entidad, participando en la categoría de Emprendimiento Naranja (Talento y creatividad). Nuestra nominación fue
    llevada a cabo teniendo en cuenta aspectos que han caracterizado a la empresa como Crecimiento, Escalabilidad Empresarial,
    Innovación, Trabajo Inclusivo e Impacto social.`,
    seeMore: 'https://senacentrogestiontunja.blogspot.com/p/emprendimiento-y-empresarismo.html'
  },
  {
    title:
      "Libro Creer y Emprender - 16 historias de emprendimientos SENA 2020",
    image: `${baseUrl}/libro-creer-para-emprender-sena.png`,
    description: `El emprendimiento Vivamos el Campo - Turismo Rural hace su aparición en el libro "Creer y emprender, 16
    historias de emprendimientos exitosos marca SENA", en el cual lo describen como una iniciativa con un aporte social resaltable,
    mencionando aspectos relevantes en el proceso que se llevó a cabo para sacar adelante la propuesta y hacer partícipes a los
    proveedores turísticos.`,
    seeMore: 'https://static.vivamoselcampo.co/uploads/libro_creer_y_emprender.pdf'
  },
  {
    title: "Medalla al Mérito Turístico 2023",
    image: `${baseUrl}/medalla-merito-turistico.jpeg`,
    description: `Vivamos el Campo ha sido condecorado con la Medalla al Mérito Turístico, en la categoría de Innovación y
    Transformación Digital. La anterior, otorgada por el Ministerio de Comercio, Industria y Turismo, en evento realizado
    el 21 de septiembre de 2023 en la ciudad de Cali.`,
    seeMore: 'https://fb.watch/pQWDHnpe8t/'
  },
  {
    title: "Aparición en los documentales Actos de Fe - SENA 2023",
    image: `${baseUrl}/documental-actos-de-fe.jpg`,
    description: `En el capítulo número 7 de los documentales "Actos de Fe" del Servicio Nacional de Aprendizaje SENA, Vivamos
    el Campo es resaltado través de la historia de Douglas Velásquez. Allí describen: "¡Colombia es diversidad, es identidad, es
    colores, es magia y naturaleza! Viajar profundo a la sierra, la costa, los volcanes y desiertos nos hará descubrir nuestras fortalezas.
    Douglas Velásquez en la serie Actos de Fé del Sena Comunica nos llevará al latir de la tierra, del campo y cómo logró ser exitoso
    respetando sus entornos."`,
    seeMore: 'https://youtu.be/N4zswu_GTKA?si=3j_OfwQm4-QFuwku&t=84'
  }
];

export default prizesList;



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/assets/prizesList.js